import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CreateAccountRequest } from 'src/app/contract-flow/models/seller.model';
import { addCustomLoader, removeCustomLoader } from 'src/app/@store/app.actions';
import { finalize, from, Observable } from 'rxjs';

@Injectable()
export class HostedFieldsService {
  constructor(private readonly store: Store) {}

  public tokenize(
    recipientDetails: CreateAccountRequest,
    { tokenize: tokenize }: any,
  ): Observable<{ token: string; card: { cardMask: string } }> {
    const loaderName = 'tokenize cc';
    this.store.dispatch(addCustomLoader({ loaderName }));

    const sale = {
      payerFirstName: recipientDetails.seller_first_name,
      payerLastName: recipientDetails.seller_last_name,
      payerEmail: recipientDetails.seller_email,
      payerPhone: recipientDetails.seller_phone,
      payerSocialId: recipientDetails.seller_social_id,

      total: {
        label: 'Order #123123',
        amount: {
          currency: 'ILS',
          value: '5.00',
        },
      },
    };

    return from<Observable<{ token: string; card: { cardMask: string } }>>(tokenize(sale)).pipe(
      finalize(() => {
        this.store.dispatch(removeCustomLoader({ loaderName }));
      }),
    );
  }
}
